/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

export default asciiWords;



//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/~/lodash-es/_asciiWords.js
// module id = 3374
// module chunks = 0